import * as actionTypes from '../actions/actionsType';

const initialState = {
    lessons: [],
    groupId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_LESSONS_CARDS_START:
            return { ...state, lessons: action.result };
        case actionTypes.SELECT_GROUP_ID:
            return { ...state, groupId: action.id };
        default:
            return state;
    }
};

export default reducer;